import { useState } from "react";

export const useClipboard = (resetTimeout = 1000) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);

        // Reset copied state after timeout
        setTimeout(() => setCopied(false), resetTimeout);
      })
      .catch((error) => {
        console.error("Clipboard copy failed:", error);
      });
  };

  return { copied, copyToClipboard };
};
